import ContentWithProgress, { Props } from './ContentWithProgress'

export default ContentWithProgress

export type ContentProps = Props
